import { createContext, useContext, useState, useEffect } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const KEY = "vitalis_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [promoCode, setPromoCode] = useState("");

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.product_id);
      if (existing) {
        return prev.map((i) => i.product_id === product.product_id
          ? { ...i, qty: Math.min(99, i.qty + qty) } : i);
      }
      return [...prev, {
        product_id: product.product_id, title: product.title, price: product.price,
        cover: product.cover, category: product.category, qty,
      }];
    });
    toast.success("Ajouté au panier");
  };

  const setQty = (product_id, qty) =>
    setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, qty: Math.max(1, Math.min(99, qty)) } : i));

  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => { setItems([]); setPromoCode(""); };
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, promoCode, setPromoCode }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
